import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import { Buffer } from 'buffer';

// Buffer를 전역 객체로 설정
window.Buffer = window.Buffer || Buffer;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);